export const BodyFont = '"Jungka", "Helvetica", "sans-serif"';

export const HeadlineFont = '"GT Pressura", "Helvetica", "sans-serif"';
